import { useTranslation } from "react-i18next";
import Regions from "./pages/Regions";
import Companies from "./pages/Companies";
import Brands from "./pages/Brands";
import BusinessRegistration from "./pages/admin/BusinessRegistration/BusinessRegistration";
import PreDefinedJobs from "./pages/PreDefinedJobs";
import AddPredefinedJob from "./pages/AddPredefinedJob";
import PredefinedJobTemplate from "./pages/PredefinedJobTemplate";
import Locations from "./pages/Locations";
import EditBrand from "./pages/Brands/Edit-Brand";
import AddCompany from "./pages/AddCompany";
import AddRegion from "./pages/AddRegion";
import AddLocation from "./pages/Locations/AddLocation";
import AddBrand from "./pages/AddBrand";
import CannedMessages from "./pages/CannedMessages";
import ManageBusinessUsers from "./pages/admin/ManageBusinessUsers";
import AddUserPage from "./pages/admin/AddUserPage";
import EditPasswordPage from "./pages/admin/EditPassword";
import AddJobSeeker from "./pages/AddJobSeeker";
import JobSeekers from "./pages/JobSeekers";
import AddPrecannedMessage from "./pages/AddPrecannedMessage";
import GeneralSettings from "./pages/admin/GeneralSettings";
import AddressBook from "./pages/admin/AddressBook";
import Certifications from "./pages/admin/Certifications";
import AddCertification from "./pages/admin/Certifications/AddCertification";
import Settings from "./pages/admin/Settings/Settings";
import TurnKeyLogin from "./pages/TurnKey/TurnKeyLogin";
import AccountRegistration from "./pages/TurnKey/AccountRegistration";
import AccountConfirmation from "./pages/TurnKey/AccountConfirmation";
import { LoadingScreen } from "./pages/TurnKey/LoadingScreen";
import AdminControlPanel from "./pages/admin/AdminControlPanel/AdminControlPanel";
import Dashboard from "./pages/Dashboard";
import Redirect from "./components/Redirect";
import AddAddress from "./pages/admin/AddressBook/AddAddress";
import GlobalSearch from "./pages/GlobalSearch";
import Stripe from "./pages/admin/Stripe/Stripe";
import StripeDetails from "./pages/admin/Stripe/StripeDetails";

const useRoutesList = () => {
  const { t } = useTranslation();

  return [
    // admin routes
    {
      name: "Admin-Control-Panel",
      path: "/control-panel",
      element: <AdminControlPanel />,
      auth: true,
    },
    {
      name: "Manage Business Users",
      path: "/admin/manage-business-users",
      element: <ManageBusinessUsers />,
      auth: true,
    },
    {
      name: "Add Business Users",
      path: "/admin/manage-business-users/add",
      element: <AddUserPage />,
      auth: true,
    },
    {
      name: "Edit Business User",
      path: "/admin/manage-business-users/edit/:userId",
      element: <AddUserPage />,
      auth: true,
    },
    {
      name: "Edit Business User",
      path: "/admin/manage-business-users/password-edit/:userId",
      element: <EditPasswordPage />,
      auth: true,
    },
    {
      name: "General Settings",
      path: "/admin/general-settings",
      element: <GeneralSettings />,
      auth: true,
    },
    {
      name: "Address Book",
      path: "/admin/address-book",
      element: <AddressBook />,
      auth: true,
    },
    {
      name: "Add Address",
      path: "/admin/address-book/add",
      element: <AddAddress />,
      auth: true,
    },
    {
      name: "Edit Address",
      path: "/admin/address-book/:addressId/edit",
      element: <AddAddress />,
      auth: true,
    },
    {
      name: "Certification",
      path: "/admin/certifications",
      element: <Certifications />,
      auth: true,
    },
    {
      name: "Add Certification",
      path: "/admin/certifications/add",
      element: <AddCertification />,
      auth: true,
    },
    {
      name: "Stripe Management",
      path: "/admin/stripe",
      element: <Stripe />,
      auth: true,
    },
    {
      name: "Stripe Details",
      path: "/admin/stripe/location/:locationId",
      element: <StripeDetails />,
      auth: true,
    },
    {
      name: "Manage Job Seekers",
      path: "/job-seekers",
      element: <JobSeekers />,
      auth: true,
    },
    {
      name: "Edit Job Seeker",
      path: "/job-seekers/edit/:id",
      element: <AddJobSeeker />,
      auth: true,
    },
    {
      name: "Admin Dashboard",
      path: "/dashboard",
      element: <Dashboard />,
      auth: true,
    },
    {
      name: "Global Search",
      path: "/global-search",
      element: <GlobalSearch />,
      auth: true,
    },
    {
      name: "Companies",
      path: "/companies",
      element: <Companies />,
      auth: true,
    },
    {
      name: "Add Company",
      path: "/companies/add",
      element: <AddCompany />,
      auth: true,
    },
    {
      name: "Business Registration",
      path: "/companies/registration",
      element: <BusinessRegistration />,
      auth: true,
    },
    {
      name: "Regions",
      path: "/companies/regions",
      element: <Regions />,
      auth: true,
    },
    {
      name: "Add Region",
      path: "/companies/regions/add",
      element: <AddRegion />,
      auth: true,
    },
    {
      name: "Brands",
      path: "/companies/brands",
      element: <Brands />,
      auth: true,
    },
    {
      name: "Add Brand",
      path: "/companies/brands/add",
      element: <AddBrand />,
      auth: true,
    },
    {
      name: "Edit Brand",
      path: "/companies/brands/:id/edit",
      element: <EditBrand />,
      auth: true,
    },
    {
      name: "Edit Brand",
      path: "/companies/brands/:brandId",
      element: <EditBrand />,
      auth: true,
    },
    {
      name: "Locations",
      path: "/companies/locations",
      element: <Locations />,
      auth: true,
    },
    {
      name: "Add Location",
      path: "/companies/locations/add",
      element: <AddLocation />,
      auth: true,
    },
    {
      name: "Edit Location",
      path: "/companies/locations/:id/edit",
      element: <AddLocation />,
      auth: true,
    },
    {
      name: "Predefined Jobs",
      path: "/predefined-jobs",
      element: <PreDefinedJobs />,
      auth: true,
    },
    {
      name: "Add Predefined",
      path: "/predefined-jobs/add",
      element: <AddPredefinedJob />,
      auth: true,
    },
    {
      name: "Edit Predefined",
      path: "/predefined-jobs/edit/:jobId",
      element: <PredefinedJobTemplate />,
      auth: true,
    },
    {
      name: "Business Showcase Public Profile",
      path: "/heyhire/:city?",
      element: <Redirect to="https://heyhire.app" />,
      auth: false,
    },
    { name: "settings", path: "/settings", element: <Settings />, auth: true },
    {
      name: "TurnKey",
      path: "/easy-login",
      element: <TurnKeyLogin />,
    },
    {
      name: "TurnKey",
      path: "/easy-login/:activationCode",
      element: <TurnKeyLogin />,
    },
    {
      name: "TurnKey",
      path: "/easy-registration",
      element: <AccountRegistration />,
    },
    {
      name: "TurnKey",
      path: "/easy-confirmation",
      element: <AccountConfirmation />,
    },
    {
      name: "TurnKey",
      path: "/loading-profile",
      element: <LoadingScreen />,
    },
    {
      name: "test",
      path: "/test-me",
      element: <TurnKeyLogin />,
    },
    {
      name: t("message.canned-messages"),
      path: "/messages/canned-messages",
      element: <CannedMessages />,
      auth: true,
    },
    {
      name: t("message.add-message"),
      path: "/messages/canned-messages/add",
      element: <AddPrecannedMessage />,
      auth: true,
    },
    {
      name: t("message.edit-messages"),
      path: "/messages/canned-messages/:id/edit",
      element: <AddPrecannedMessage />,
      auth: true,
    },
  ];
};

export default useRoutesList;
